<script setup lang="ts">
import { PLayout } from '@previo/design-system'
import { RouterView } from 'vue-router'
import { Color } from '@previo/codebooks'
import { onBeforeMount } from 'vue'
import { useFeatureFlags } from '@previo/feature-flags'
import PageLoader from '~/layouts/components/PageLoader.vue'

onBeforeMount(async () => {
  await useFeatureFlags().waitForInit()
})
</script>

<template>
  <p-layout :color="Color.GREY_100">
    <div class="p-safe-area-top">
      <router-view v-slot="{ Component }">
        <template v-if="Component">
          <suspense timeout="200">
            <component :is="Component" />

            <template #fallback>
              <page-loader />
            </template>
          </suspense>
        </template>
      </router-view>
    </div>
  </p-layout>
</template>
